import script from "./CustomNotification.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomNotification.vue?vue&type=script&setup=true&lang=ts"

import "./CustomNotification.vue?vue&type=style&index=0&id=0cccd2d1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cccd2d1"]])

export default __exports__